import { render, staticRenderFns } from "./homeTopUser.vue?vue&type=template&id=0527f436"
import script from "./homeTopUser.vue?vue&type=script&lang=js"
export * from "./homeTopUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports